module.exports = __webpack_public_path__ + "media/images/client-33-6842d8aabc8fb1bf594bd3460947c4c6.svg";